export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: "Isn't this asking me to interrogate my students? That's not my job.",
    a: 'Correct, and this system agrees with you. SCREEN is not an intake interview you run on your class — it is what you do in the eight seconds after a student volunteers something, which they do whether you ask or not. Before class, mid-pose, or on the way out the door. The system exists for that moment, not to send you looking for problems.',
  },
  {
    q: "Can't I find all this free online?",
    a: 'You can find pieces, scattered across hundreds of blog posts and videos, with no order and no way to reach them while someone is standing in front of you. This is thirty conditions and nine populations, one page each, organized by the posture families your class is actually built from. You are not paying for information. You are paying for retrieval.',
  },
  {
    q: "I've already done trainings on injuries and modifications. What's different?",
    a: 'Every other resource tells you what to know. This one tells you what to say — nine word-for-word scripts, a glossary of what students actually say, and phrase-by-phrase replacements for the cues that sound like a diagnosis. A course is watched once in March; the student asks in October.',
  },
  {
    q: 'Does this put me at legal risk?',
    a: "The opposite is the design goal. Volume 6 maps the system to Yoga Alliance's published Scope of Practice principle by principle, including explicit informed consent before hands-on assists, refer-out signals at two levels, and factual incident documentation. The system exists so you never diagnose — it marks the line rather than crossing it.",
  },
  {
    q: 'Does it come with CE hours?',
    a: 'Not currently. This is a reference system, not a continuing-education course — the two do different jobs. A CE course gives you hours once; this gives you an answer every class.',
  },
  {
    q: 'Does it work for my style?',
    a: 'Yes. Every condition page is organized by posture family, not by style, and ends with a specific note for vinyasa and hot, hatha, yin and restorative, and Ashtanga — because a long yin hold and a fast vinyasa flow place very different demands on the same shape.',
  },
  {
    q: '300 pages sounds like a lot. Will I actually use it?',
    a: 'You do not read it. You consult it. Volume 1 is the only one you read straight through, in about fifteen minutes. Everything after that opens on a one-page Quick Card, and Bonus 3 sets your files up so you find any condition in under 90 seconds on your phone.',
  },
  {
    q: 'How do I get it after I pay?',
    a: 'Instantly. You get an email with download links to all six volumes and the five bonuses as PDFs, readable on your phone, tablet or laptop. Nothing ships, nothing expires, and you can re-download them any time.',
  },
  {
    q: "What if it's not for me?",
    a: '7-day guarantee, full refund, no questions asked.',
  },
];
